<script>
  // One choice out of a few, as one joined control with its label in front:
  // "View as [Separate | Aligned | Scale]". The options sit in one bordered
  // strip and the chosen one is filled, so it reads as a control and not as a
  // row of tags. `options` is [{ id, label }].
  let { label, options = [], selected, onselect } = $props();
</script>

<div class="segmented" role="group" aria-label={label}>
  <span class="wf2-caption">{label}</span>
  <div class="strip">
    {#each options as o}
      <button type="button" class:active={selected === o.id} aria-pressed={selected === o.id}
        onclick={() => onselect(o.id)}>{o.label}</button>
    {/each}
  </div>
</div>

<style>
  .segmented { display: inline-flex; align-items: center; gap: 8px; }
  .strip {
    display: inline-flex;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    overflow: hidden;
    background: var(--surface);
  }
  button {
    font: inherit;
    font-size: .85rem;
    padding: 4px 12px;
    border: 0;
    background: transparent;
    color: var(--text);
    cursor: pointer;
  }
  button + button { border-left: 1px solid var(--border); }
  button:hover:not(.active) { background: var(--surface-2); }
  button:focus-visible { outline: 2px solid var(--accent); outline-offset: -2px; }
  button.active { background: var(--accent); color: #fff; font-weight: 650; }
</style>
